import React, { useState, useEffect, Fragment, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { timesheetApi } from "../../../services";
import properties from "../../../config/environmentProperties";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import DeallocateProject from "./deallocatProjectDialoge";
import { useNavigate } from "react-router-dom";
import { NewAllocation } from "../../allocation/newAllocation";
import { InputText } from "primereact/inputtext";
import NewProfile from "./newProfile";
import Profile from "./user_profile";
import { Menu } from 'primereact/menu';
import { classNames } from "primereact/utils";
import { useFormik } from "formik";
import CONF from "../../../config/appProperties";
import { Paginator } from "primereact/paginator";
import "./style.scss";

export const Team = () => {
  const menu = useRef(null);
  const [employeeList, setEmployeeList] = useState([]);
  const [deallocationDialog, setDeallocationDialog] = useState(false);
  const [clickdDeallocation, setClickdDeallocation] = useState([]);
  const imgPath = properties.currentEnvironment.docPath + "images/";
  const [editIconVisible, setEditIconVisible] = useState(true);
  const [allocTypeVisible, setAllocTypeVisible] = useState(true);
  const [allocHeader, setAllocHeader] = useState();
  const [deAllocBtn, setDeAllocBtn] = useState(true);
  const [checkboxAlloc, setCheckBoxAlloc] = useState(true);
  const navigate = useNavigate();
  const [showNewAllocation, setShowNewAllocation] = useState(false);
  const [clickedUserData, setClickedUserData] = useState([]);
  const [clickedUserECN, setClickedUserECN] = useState("");
  const [clickedUserId, setClickedUserId] = useState("");
  // const [vProfile, setvProfile] = useState(false);
  const [userProfile, setUserProfile] = useState(false);
  const [userProfileDetails, setUserProfileDetails] = useState([]);
  const [filterObj, setFilterObj] = useState('');
  const [filterDialog, setFilterDialog] = useState(false);
  const [users, setUsers] = useState([]);
  const [showMessage, setShowMessage] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const [resourceAvailable, setResourceAvailable] = useState("");
  const [totalRecords, setTotalRecords] = useState(0);
  const [contentFirst, setContentFirst] = useState(0);
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(CONF.pageSize);
  const [basicFirst, setBasicFirst] = useState(0);
  const [basicRows, setBasicRows] = useState(10);
  const [rowsPerPageOptions, setRowsPerPageOptions] = useState(CONF.rowsPerPageOptions);

  let count = 0;
  useEffect(() => {
    if (count == 0) {
      getManagerUserInfo({ "pageNum": 0, "pageSize": size });
    }
    count++;
  }, []);


  const getManagerUserInfo = (param = {}) => {
    if (param.pageNo === undefined) {
      setPage(0);
      setContentFirst(0);
    }
    timesheetApi.getUsersBySuperior(param).then((resp) => {
      try {
        setEmployeeList(resp?.data?.data);
        setTotalRecords(resp?.data?.totalElement);
      } catch (error) {
        // Error handle
      }
    });
  };

  const onClickDeallocation = (rowData) => {
    const filterAllocatedData = rowData?.Allocations?.filter((obj) => {
      return (obj.status === 1 || obj.status === 3);
    });
    setClickedUserData(rowData);
    setResourceAvailable(rowData?.availability);
    setClickdDeallocation(filterAllocatedData);
    setDeallocationDialog(true);
  };

  const onHide = () => {
    getManagerUserInfo({ "pageNum": 0, "pageSize": size });

    setDeallocationDialog(false);
  };

  /* Dialog Box for Add/Edit Transit Info Form Start */
  const OpenDeallocationDialog = () => {
    const header = () => {
      return (
        <div className="grid">
          <div className="col-12">
            <h1 style={{ fontSize: "25px", textTransform: "capitalize", margin: "0" }}>
              Update Project - {" "}
              {clickedUserData.firstName.charAt(0).toUpperCase() +
                clickedUserData.firstName.slice(1) +
                " " +
                clickedUserData.lastName.charAt(0).toUpperCase() +
                clickedUserData.lastName.slice(1)}{" "}
            </h1>
          </div>
          <div className="col-12 mt-2 text-right popup_btn">
            <Button icon="pi pi-plus-circle" label="Create Allocation" className="p-button-sm p-button-rounded p-button-icon"
              onClick={() => {
                setShowNewAllocation(true);
                setDeallocationDialog(false);
              }}
            />
          </div>
        </div>
      );
    };

    return allocHeader ? (
      <Dialog width="80vm" header={header} visible={deallocationDialog} onHide={() => onHide()}>
        <DeallocateProject clickedUser={clickedUserData} editIconVisible={editIconVisible} allocTypeVisible={allocTypeVisible} deAllocBtn={deAllocBtn} checkboxAlloc={checkboxAlloc} onClose={(e) => {
          setDeallocationDialog(false);
          getManagerUserInfo({ "pageNum": 0, "pageSize": size });
        }}
          projectData={clickdDeallocation}
          resourceAvailablity={resourceAvailable}
        />
      </Dialog>
    ) : (
      <Dialog width="80vm" header="Project Deallocation" visible={deallocationDialog} onHide={() => onHide()}>
        <DeallocateProject editIconVisible={editIconVisible} allocTypeVisible={allocTypeVisible} deAllocBtn={deAllocBtn} checkboxAlloc={checkboxAlloc} onClose={(e) => {
          setDeallocationDialog(false);
          getManagerUserInfo({ "pageNum": 0, "pageSize": size });
        }}
          projectData={clickdDeallocation}
          resourceAvailablity={resourceAvailable}
        />
      </Dialog>
    );
  };
  /* Dialog Box for Add/Edit Transit Info Form End */
  const getCurrentUserDetails = (rowData) => {
    setClickedUserECN(rowData?.ecn);
    setUserProfile(true);
    setClickedUserId(rowData?.id);
    // setvProfile(true);
  };

  const UserProfile = () => {
    const headerText = "Profile";
    return (
      <Fragment>
        <Dialog className="custom_popup" header={headerText} visible={userProfile} onHide={() => setUserProfile(false)} style={{ width: "70%", height: "70%" }}>
          <Profile userECN={clickedUserECN} userDetails={userProfileDetails} onClose={(e) => setUserProfile(false)} />
          <NewProfile getRowId={clickedUserId} />
        </Dialog>
      </Fragment>
    );
  };

  const [currentData, setCurrentData] = useState({});
  const reviewActionBodyTemplate = (rowData) => {
    const items = [
      { label: 'Profile', items: [{ label: "View Profile", icon: "pi pi-user", command: (e) => { getCurrentUserDetails(currentData); }, },] },
      { label: 'Allocation', items: [{ label: "Edit Allocation", icon: "pi pi-pencil", className: "p-button-rounded p-button-primary mr-1", command: () => { setEditIconVisible(true); setAllocTypeVisible(true); setAllocHeader(true); setDeAllocBtn(false); setCheckBoxAlloc(false); onClickDeallocation(currentData); }, },] },
      {
        label: 'Timesheet', items: [
          { label: "Review Timesheet", icon: "pi pi-eye", command: (e) => { navigate("/timesheets?action=app&id=" + currentData.id + "&status=REVIEW"); }, },
          { label: "Recall Timesheet", icon: "pi pi-arrow-circle-right", command: (e) => { navigate("/timesheets?action=app&id=" + currentData.id + "&status=RECALL"); }, },
          { label: "Approved Timesheet", icon: "pi pi-check-circle", command: (e) => { navigate("/timesheets?action=app&id=" + currentData.id + "&status=APPROVED"); }, },
          { label: "Locked Timesheet", icon: "pi pi-lock", command: (e) => { navigate("/timesheets?action=app&id=" + currentData.id + "&status=LOCKED"); }, },
          { label: "Create Timesheet", icon: "pi pi-plus-circle", command: (e) => { navigate("/timesheets?action=app&id=" + currentData.id + "&status=CREATE"); }, },]
      },
      {
        label: 'Attendance', items: [
          { label: "Review Attendance", icon: "pi pi-eye", command: (e) => { navigate("/attendance?action=app&id=" + currentData.id + "&type=0"); }, },
          { label: "Pending Attendance", icon: "pi pi-arrow-circle-right", command: (e) => { navigate("/attendance?action=app&id=" + currentData.id + "&type=1"); }, },]
      },
      {
        label: 'Timeline', items: [
          { label: "View Timeline", icon: "pi pi-arrow-up-right", command: (e) => { navigate("/timeline?action=app&id=" + currentData.id + "&type=0"); }, },]
      },
    ];
    return (<>
      <Menu style={{ width: '180px' }} id={"m-" + rowData.id} model={items} popup ref={menu} />
      <Button className="p-button-rounded p-button-text" id={"b-" + rowData.id} icon="pi pi-ellipsis-v"
        onClick={(event) => { setCurrentData(rowData); menu.current.toggle(event) }} aria-controls={"m-" + rowData.id} aria-haspopup />
    </>);
  };

  const designationBodyTemplate = (item) => {
    return item?.Designation?.title;
  };

  const projectBodyTemplate = (rowData) => {
    let proName = [];
    rowData?.Allocations?.map((el) => {
      if (el.status === 1) {
        proName.push(el?.Project?.title);
      }
    });
    return <p>{proName.join(", ")}</p>;
  };

  const imageBodyTemplate = (item) => {
    return (
      <div className="flex align-items-center gap-2">
        {item?.photo === "" || item?.photo === null ? (
          <span
            className="photo-span"
            style={{ height: "35px", width: "35px", borderRadius: "50%", border: "2px solid #d7e9ff", display: "flex", alignItems: 'center', justifyContent: 'center', fontSize: "18px", fontWeight: "600", color: "#1369b6", padding: '5px', paddingTop: '1px' }}
          >
            {item?.firstName.toUpperCase().substr(0, 1)}
            {item?.lastName.toUpperCase().substr(0, 1)}
          </span>
        ) : (
          <img className="user_pic"
            style={{
              height: "40px", width: "40px", borderRadius: "50%", border: "3px solid #d7e9ff", Top: "16px", bottom: "16px", left: "16px",
            }} src={imgPath + item?.photo || ""} alt=""
          />
        )}
        <div>{item?.firstName + " " + item?.lastName}</div>
      </div>
    );
  };
  const fetchStatus = (status) => {
    if (status === 0) return "INACTIVE";
    if (status === 1) return "ACTIVE";
  };

  const fetchStatusColor = (status) => {
    if (status === 0) return "red";
    if (status === 1) return "#008000";
  };

  const bgvBodyTemplate = (data) => {
    if (data?.background_verification === true && data?.bgv_comment === "Closed") {
      return <i className="pi pi-check-circle" style={{ color: "#008000", fontSize: "1.2rem" }} title={"Verification Completed"}/>;
    }

    if (data?.background_verification === true && data?.bgv_comment === "Pending Verification") {
      return <i className="pi pi-shield" style={{ color: "#008000", fontSize: "1.2rem" }} title={"Data pending from HR team to be update"} />;
    }
    return (
      <i
        className="pi pi-info-circle"
        style={{ fontSize: "1.2rem", cursor: "default", color: "#6c757d" }}
        title={data?.bgv_comment || "No comment"}
      />
    );
  };

  const statusBodyTemplate = (data) => {
    return (
      <span
        style={{
          color: fetchStatusColor(data?.status),
          borderRadius: "8px",
          fontSize: "12px",
          fontWeight: "700",
        }}
      >
        {fetchStatus(data?.status)}
      </span>
    );
  };


  const searchUser = (data) => {
    setShowButton(true);
    var dataObj = {};
    if (data?.ecn !== "") {
      dataObj.ecn = data?.ecn;
    }
    if (data?.firstName !== "") {
      dataObj.firstName = data?.firstName;
    }
    if (data?.lastName !== "") {
      dataObj.lastName = data?.lastName;
    }
    if (data?.email !== "") {
      dataObj.email = data?.email;
    }
    if (data?.phone !== "") {
      dataObj.phone = data?.phone;
    }
    if (data?.bu !== "") {
      dataObj.businessUnitId = data?.bu;
    }
    let isClear = true;
    for (let v of Object.keys(data)) {
      if (data[v] != undefined && data[v] != '') {
        isClear = false
      }
    }
    if (isClear) { setShowMessage(false) }

    try {
      setFilterObj(dataObj);
      timesheetApi.filterTeamData(dataObj).then(
        (resp) => {
          if (resp.status === 200) {
            setEmployeeList(resp?.data?.data);
            setShowButton(false);
            searchForm.resetForm();
            setFilterDialog(false);
          }
        },
        (error) => {
          setUsers();
          setShowButton(true);
        }
      );
    } catch (error) { }
  };


  const searchForm = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      ecn: "",
      phone: "",
      designation: "",
      bu: "",
      rm: ""
    },
    validate: (data) => {
      let errors = {};
      return errors;
    },
    onSubmit: (data) => {
      setShowMessage(true);
      searchUser(data);
      searchForm.resetForm();
    },
  });

  const isFormFieldValid = (name) =>
    !!(searchForm.touched[name] && searchForm.errors[name]);
  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{searchForm.errors[name]}</small>
      )
    );
  };

  const tableHeader = () => {

    return (
      <Fragment>
        <div className="grid">
          <div className="col-6">
            <span className="heading">
              <h1 className="p-0">My Teams</h1>
            </span>
          </div>
          <div className="col-6 mt-3 mb-2">
            <span className="heading">
              <div className="heading-actions">
                <Button icon="pi pi-replay" className="p-button-rounded p-button-help p-button-text" aria-label="Replay" onClick={() => { setFilterObj(''); getManagerUserInfo({ "pageNum": 0, "pageSize": size }) }} />
                <Button icon="pi pi-filter" className="p-button-rounded p-button-help p-button-text" aria-label="Filter" onClick={() => setFilterDialog(true)} />
              </div>
            </span>
          </div>
        </div>
      </Fragment>
    );
  };


  const SearchForm = () => {
    return (
      <Fragment>
        <Dialog header="User Filter" visible={filterDialog} position="right" modal style={{ width: '500px' }}
          onHide={() => setFilterDialog(false)}
          draggable={false} resizable={false}>
          <form onSubmit={searchForm.handleSubmit}>
            <div className="grid p-fluid">
              <div className="col-6 field">
                <label htmlFor="firstName" className={classNames({ "p-error": isFormFieldValid("firstName"), })}>First Name</label>
                <span className="p-float-label">
                  <InputText name="firstName" value={searchForm.values.firstName} onChange={searchForm.handleChange} />
                </span>
              </div>
              <div className="col-6 field">
                <label htmlFor="lastName" className={classNames({ "p-error": isFormFieldValid("lastName"), })}>Last Name</label>
                <span className="p-float-label">
                  <InputText name="lastName" value={searchForm.values.lastName} onChange={searchForm.handleChange} />
                </span>
              </div>
              <div className="col-6 field">
                <label htmlFor="ecn" className={classNames({ "p-error": isFormFieldValid("ecn"), })}>ECN</label>
                <span className="p-float-label">
                  <InputText name="ecn" value={searchForm.values.ecn} onChange={searchForm.handleChange} />
                </span>
              </div>
              <div className="col-6 field">
                <label className={classNames({ "p-error": isFormFieldValid("email") })}>Email Address</label>
                <span className="p-float-label">
                  <InputText name="email" value={searchForm.values.email} onChange={searchForm.handleChange} />
                </span>
              </div>
              <div className="col-6 field">
                <label className={classNames({ "p-error": isFormFieldValid("bu") })}>Business Unit</label>
                <span className="p-float-label">
                  <InputText name="bu" value={searchForm.values.bu} onChange={searchForm.handleChange} />
                </span>
              </div>
              <div className="col-6 field">
                <label className={classNames({ "p-error": isFormFieldValid("phone") })}>Phone</label>
                <span className="p-float-label">
                  <InputText name="phone" value={searchForm.values.phone} onChange={searchForm.handleChange} />
                </span>
              </div>
            </div>
            <div className="col-12">
              <Button type="submit" icon="pi pi-search" label="Search" className="p-button-rounded filter_btn" />
            </div>
          </form>
        </Dialog>
      </Fragment>
    );
  };

  const onBasicPageChange = (e) => {
    setBasicFirst(e.first);
    setSize(e.rows);
    setPage(page + e.page);
    setBasicRows(e.rows);
    var param = {
      pageNum: e.page,
      pageSize: e.rows,
    }
    getManagerUserInfo(param);
  };

  const footer = (
    <React.Fragment>
      <Paginator
        first={basicFirst}
        rows={basicRows}
        totalRecords={totalRecords}
        onPageChange={onBasicPageChange}
        rowsPerPageOptions={rowsPerPageOptions}
        paginatortemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
      ></Paginator>
    </React.Fragment>
  );

  return (
    <div className="grid">
      {SearchForm()}
      {UserProfile()}
      <div className="col-12">
        <NewAllocation teamAllocation={employeeList} clickedUser={clickedUserData} show={showNewAllocation} setShow={setShowNewAllocation} reqMgrAlloc={true}
        />
        <DataTable dataKey="id" value={employeeList} responsiveLayout="scroll" header={tableHeader} footer={footer} emptyMessage="No Employee found."
          rowClassName={(data) => data?.background_verification !== true ? { "bgv-unverified-row": true } : {}}
        >
          <Column field="ecn" header="ECN" headerStyle={{ width: "4rem" }} sortable></Column>
          <Column header="Name" body={imageBodyTemplate} className="initCap"></Column>
          <Column header="Allocated Project" body={projectBodyTemplate}></Column>
          <Column field="email" header="Email Address" headerStyle={{ width: "8rem" }} sortable></Column>
          <Column field="phone" header="Mobile No." headerStyle={{ width: "9rem" }} sortable></Column>
          <Column header="Designation" body={designationBodyTemplate}></Column>
          <Column field="location" header="Location" sortable></Column>
          <Column field="" header="BGV" body={bgvBodyTemplate} style={{ width: "60px", textAlign: "center" }}></Column>
          <Column header="Status" body={statusBodyTemplate} headerStyle={{ width: "8rem" }}></Column>
          <Column field="status" header="Action" body={reviewActionBodyTemplate} headerStyle={{ width: "5rem" }}></Column>
        </DataTable>
      </div>
      {OpenDeallocationDialog()}
    </div>
  );
};